<script setup lang="ts">
import { useI18n } from 'vue-i18n';

const { t } = useI18n();
</script>

<template>
  <v-container class="containerStandard">

    <p class="textHeadline">{{ t('pageNotFound') }}</p>

    <p class="textDescriptor">
      {{ t('noCommunityFound') }}
    </p>

  </v-container>
</template>

<style scoped lang="scss">

</style>
